import { X } from 'lucide-react';

import { Heading } from '@/components/heading';
import { tv } from '@/utils/styles';

export interface DrawerHeaderProps {
  title: string;
  icon: React.ReactNode;
  onClose?: () => void;
}

const DrawerHeader = ({ title, icon, onClose }: DrawerHeaderProps) => {
  const { closeButton, heading, headingIcon } = styles();
  return (
    <>
      <X size={24} className={closeButton()} onClick={onClose} />
      <Heading variant="h4" as="h2" className={heading()}>
        <div className={headingIcon()}>{icon}</div>
        <span className="ml-2">{title}</span>
      </Heading>
    </>
  );
};

const styles = tv({
  slots: {
    closeButton: 'absolute right-4 top-6 cursor-pointer text-text-secondary',
    heading: 'mb-4 flex items-center text-base',
    headingIcon: 'flex items-center rounded-full bg-blue-50 p-2.5 text-baseSm font-medium text-lightBlue-600',
  },
});

export { DrawerHeader };
